import { Chip } from '@mui/material';
import {
  COLLECTION_BANNER_TYPE,
  COLLECTION_BANNER_TYPE_COLOR,
} from 'modules/cms/collections/constants/collection-types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import SimpleBanner from 'components/icons/banners/SimpleBanner';
import MultiBanner from 'components/icons/banners/MultiBanner';
import GridBanner from 'components/icons/banners/GridBanner';

const BANNER_ICONS = {
  [COLLECTION_BANNER_TYPE.SIMPLE_BANNER]: SimpleBanner,
  [COLLECTION_BANNER_TYPE.MULTI_BANNER]: MultiBanner,
  [COLLECTION_BANNER_TYPE.GRID_BANNER]: GridBanner,
  [COLLECTION_BANNER_TYPE.SIDE_BY_SIDE_BANNER]: GridBanner,
};

export const CollectionBannerTypeChip = ({ type, isButton }: { type?: COLLECTION_BANNER_TYPE; isButton?: boolean }) => {
  const { t } = useTranslation('collection');

  const bgColor = useMemo(() => COLLECTION_BANNER_TYPE_COLOR[type ?? COLLECTION_BANNER_TYPE.SIMPLE_BANNER], [type]);
  const IconComponent = type ? BANNER_ICONS[type] : null;

  if (!type) return null;

  return (
    <Chip
      className="px-4"
      sx={{ backgroundColor: bgColor, color: '#fff', ...(isButton && { borderRadius: '4px', minHeight: 36 }) }}
      label={t(`type.${type ?? COLLECTION_BANNER_TYPE.SIMPLE_BANNER}`)}
      icon={IconComponent ? <IconComponent /> : undefined}
    />
  );
};
